module.exports = __webpack_public_path__ + "img/260.e2f45032.jpg";